<template>
    <router-view></router-view>
</template>

<script>

    export default {
        name: 'layout',
        data() {
            return {
                
            }
        },
       
    }
</script>
<style lang="scss">
     html, body, .el-container {width: 100%;height: 100%;overflow-x: hidden;}

    * { margin: 0; padding: 0;}

    
</style>



// WEBPACK FOOTER //
// src/pages/layout.vue